import React, { forwardRef, HTMLProps } from 'react';
import cx from 'classnames';
import styles from './Paper.module.css';
import CustomerServiceBubbleTop from '../CustomerServiceBubbleTop/CustomerServiceBubbleTop';

type Props = {
  withShadow?: boolean;
  withBackground?: boolean;
  dense?: boolean;
} & HTMLProps<HTMLDivElement>;

const Paper = forwardRef<HTMLDivElement, Props>(
  (
    { className, withShadow, withBackground, dense, children, ...props },
    ref
  ) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cx(
          styles.paper,
          withShadow && styles.withShadow,
          withBackground && styles.withBackground,
          dense && styles.dense,
          className
        )}
      >
        {children}
      </div>
    );
  }
);

export function SpeechBubbleHeader(props: HTMLProps<HTMLDivElement>) {
  return (
    <div {...props} className={cx(styles.header, props.className)}>
      <div className={styles.title}>{props.children}</div>

      <div className={styles.customerServiceImageContainer}>
        <CustomerServiceBubbleTop />
      </div>
    </div>
  );
}

export default Paper;
